import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DenunciaPage from './screens/DenunciaPage';
import { BrowserRouter as Router, Routes , Route } from 'react-router-dom';


import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

import 'leaflet/dist/leaflet.css';
import "leaflet-control-geocoder/dist/Control.Geocoder.css";

import "leaflet-control-geocoder/dist/Control.Geocoder.js";
import "bootstrap/dist/js/bootstrap.bundle.js";

const root = ReactDOM.createRoot(document.getElementById('root'));

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});


root.render(
  <React.StrictMode>
    <Router>
      <Routes >
        <Route path="/disquedenuncia" element={<App />} />
        <Route path="/registrar" element={<DenunciaPage />} />
      </Routes >
    </Router>
  </React.StrictMode>
);